import { Box, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';

export function PSSupplierDataGridRowDetails({
  rowId,
  isEdit,
  updateProspectiveSupplier
}) {
  const prospectiveSupplierRow = useSelector(
    (state) => state.prospectiveSupplier.prospectiveSupplierRows[rowId]
  );

  const handleChange = (event, fieldName) => {
    const newValue = event.target.value.trim();

    updateProspectiveSupplier(rowId, { [fieldName]: newValue });
  };

  const handleKeyboardChange = (event, callSetter) => {
    if (event.key === 'Tab' || event.key === 'Enter') {
      handleChange(event, callSetter);
    }
  };

  return prospectiveSupplierRow ? (
    <Box sx={{ ml: 14 }}>
      <Grid container spacing={4}>
        <Grid size={3}>
          <Typography
            variant={'body2'}
            fontWeight={'bold'}
            style={{ marginTop: '1em' }}
          >
            Key Contact Email{' '}
          </Typography>
          <TextField
            defaultValue={
              prospectiveSupplierRow?.keyContactEmail
                ? prospectiveSupplierRow.keyContactEmail
                : ''
            }
            onKeyDown={(e) => handleKeyboardChange(e, 'keyContactEmail')}
            onBlur={(e) => handleChange(e, 'keyContactEmail')}
            inputProps={{ maxLength: 70 }}
            disabled={!isEdit}
          />
        </Grid>
        <Grid size={3}>
          <Typography
            variant={'body2'}
            fontWeight={'bold'}
            style={{ marginTop: '1em' }}
          >
            Company URL
          </Typography>
          <TextField
            defaultValue={
              prospectiveSupplierRow?.companyUrl
                ? prospectiveSupplierRow.companyUrl
                : ''
            }
            onKeyDown={(e) => handleKeyboardChange(e, 'companyUrl')}
            onBlur={(e) => handleChange(e, 'companyUrl')}
            inputProps={{ maxLength: 120 }}
            disabled={!isEdit}
          />
        </Grid>
      </Grid>
    </Box>
  ) : null;
}
